import { Result } from '@ssar-app/uikit';
import { Button, HStack, Icon } from '@chakra-ui/react';
import { AiOutlineDoubleLeft } from 'react-icons/ai/index.js';
import { FaSignOutAlt } from 'react-icons/fa/index.js';
import { useHistory } from 'react-router-dom';

export const SessionTimedOut = () => {
  const history = useHistory();
  return (
    <Result
      status='warning'
      title='Session Timed Out.'
      subTitle='Sorry, the page you visited does not exist.'
      extra={
        <HStack>
          <Button
            colorScheme='gray'
            variant='outline'
            leftIcon={<Icon as={AiOutlineDoubleLeft} />}
            onClick={() => {
              history.goBack();
            }}
          >
            &nbsp; Back
          </Button>
          <Button
            colorScheme='blue'
            leftIcon={<Icon as={FaSignOutAlt} />}
            onClick={() => {
              history.replace('/logout');
            }}
          >
            &nbsp; Logout
          </Button>
        </HStack>
      }
    />
  );
};
